import PlainContent from "../../../../components/PlainContent";
import type { PlainContentProps } from "./PlainContent.d";

const PlainContentMagnitudeAdapter = ({ props: content = "" }: PlainContentProps) => (
  <PlainContent content={content[0]} />
);

export default PlainContentMagnitudeAdapter;
